module.exports = "<a [class]=\"classes\" (click)=\"click()\">{{ title }}</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/analytics-link/analytics-link.component.html
// module id = ./src/app/shared/components/analytics-link/analytics-link.component.html
// module chunks = main